export default __webpack_public_path__ + "static/media/lg_polygon.d4bc2d8f.svg";